'use client';

import { Button } from '@/components/ui/button';
import { AlertCircleIcon, Loader2Icon, RefreshCwIcon } from 'lucide-react';
import { useEffect, useState } from 'react';

const DETAIL_TIMEOUT_SECONDS = 10;

export function DocDetailLoadingCountdown() {
  const [remainingSeconds, setRemainingSeconds] = useState(
    DETAIL_TIMEOUT_SECONDS,
  );

  useEffect(() => {
    const timer = window.setInterval(() => {
      setRemainingSeconds((seconds) => Math.max(0, seconds - 1));
    }, 1000);

    return () => window.clearInterval(timer);
  }, []);

  if (remainingSeconds === 0) {
    return <DocDetailFailure />;
  }

  return (
    <div className="mb-4 rounded-xl border bg-background p-6 md:p-8">
      <div className="flex items-start gap-3">
        <Loader2Icon className="mt-0.5 h-5 w-5 shrink-0 animate-spin text-primary" />
        <div className="space-y-1">
          <h2 className="text-base font-semibold">正在获取文献详情</h2>
          <p className="text-sm text-muted-foreground">
            最多等待 {remainingSeconds} 秒，若超时请稍后重试。
          </p>
        </div>
      </div>
    </div>
  );
}

export function DocDetailFailure() {
  return (
    <div className="mb-4 rounded-xl border bg-background p-6 md:p-8">
      <div className="flex items-start gap-3">
        <AlertCircleIcon className="mt-0.5 h-5 w-5 shrink-0 text-destructive" />
        <div className="space-y-3">
          <div className="space-y-1">
            <h2 className="text-base font-semibold">文献详情获取失败</h2>
            <p className="text-sm text-muted-foreground">
              10 秒内未获取到详情，请刷新页面后重试。
            </p>
          </div>
          <Button
            type="button"
            variant="outline"
            size="sm"
            className="rounded-full"
            onClick={() => window.location.reload()}
          >
            <RefreshCwIcon className="h-4 w-4" />
            重新获取
          </Button>
        </div>
      </div>
    </div>
  );
}
